import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SugargooSpreadsheetGuide from "@/pages/article/sugargoo-spreadsheet-guide/page";
import ShippingCostGuide from "@/pages/article/sugargoo-shipping-cost-guide/page";
import SugargooReview from "@/pages/article/sugargoo-review-2026/page";
import CouponGuide from "@/pages/article/sugargoo-coupon-discount-code/page";
import WarehouseGuide from "@/pages/article/sugargoo-warehouse-guide/page";
import ShoesGuide from "@/pages/article/best-sugargoo-shoes/page";
import HoodiesGuide from "@/pages/article/sugargoo-hoodies-sweaters-guide/page";
import AccessoriesGuide from "@/pages/article/sugargoo-accessories-guide/page";
import BagsGuide from "@/pages/article/sugargoo-bags-backpacks-guide/page";
import BeginnerTutorial from "@/pages/article/sugargoo-beginner-tutorial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <SugargooSpreadsheetGuide />,
  },
  {
    path: "/sugargoo-shipping-cost-guide",
    element: <ShippingCostGuide />,
  },
  {
    path: "/sugargoo-review-2026",
    element: <SugargooReview />,
  },
  {
    path: "/sugargoo-coupon-discount-code",
    element: <CouponGuide />,
  },
  {
    path: "/sugargoo-warehouse-guide",
    element: <WarehouseGuide />,
  },
  {
    path: "/best-sugargoo-shoes",
    element: <ShoesGuide />,
  },
  {
    path: "/sugargoo-hoodies-sweaters-guide",
    element: <HoodiesGuide />,
  },
  {
    path: "/sugargoo-accessories-guide",
    element: <AccessoriesGuide />,
  },
  {
    path: "/sugargoo-bags-backpacks-guide",
    element: <BagsGuide />,
  },
  {
    path: "/sugargoo-beginner-tutorial",
    element: <BeginnerTutorial />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;